





























import glDispopicker from 'gl-uikit/src/components/gl-dispopicker.vue';
import {
    ACTION_ROUTE,
    ACTION_EMPTY_ROUTE,
    ACTION_SAVE_ROUTE,
} from '@/store/modules/planning';
import geoPanels from './components/panels.vue';
import configurator from './components/configurator.vue';

enum LoadingType {
    NEW_PLANNING = 'NEW_PLANNING',
    LOAD_FROM_DISPO = 'LOAD_FROM_DISPO'
}

export default {
    data() {
        return {
            idTrip: '',
            activeName: 'route',
            tabLoader: LoadingType.NEW_PLANNING,
            prevRoute: null,
        };
    },
    components: {
        glDispopicker,
        geoPanels,
        configurator,
    },
    beforeRouteEnter(this: any, to: any, from: any, next: any) {
        next((vm: any) => {
            vm.prevRoute = from;
        });
    },
    async mounted(this: any) {
        this.$store.commit(ACTION_EMPTY_ROUTE);
        if (this.$route.query.idTrip) {
            this.tabLoader = LoadingType.LOAD_FROM_DISPO;
            this.idTrip = this.$route.query.idTrip;
            if (!this.$store.getters.hasRoute) {
                await this.$store.dispatch(
                    ACTION_ROUTE,
                    this.$route.query.idTrip,
                );
            }
        }
    },
    computed: {
        showTruckConfiguration(this: any) {
            return this.$store.getters.isToggleEnabled('truckConfiguration');
        },
        loadDispo(this: any) {
            return this.tabLoader === LoadingType.LOAD_FROM_DISPO;
        },
        routable(this: any) {
            return Boolean(this.$store.getters.getWaypoints.length > 1);
        },
        isChanged(this: any) {
            return (
                Boolean(this.$store.getters.editing)
                || Boolean(this.$store.getters.editingEmpty)
            );
        },
        isNotifier(this: any) {
            return Boolean(this.$route.query.isNotifier);
        },
        hasAutoSave(this: any) {
            return Boolean(this.$store.getters.hasAutoSave);
        },
        disableButton(this: any) {
            return Boolean(!this.hasAutoSave && !this.isChanged && (!this.prevRoute || !this.prevRoute.params.plateId));
        },
    },
    methods: {
        loadDispoData(this: any, idTrip: string) {
            if (this.idTrip !== idTrip) {
                this.$router.replace({
                    ...this.$router.currentRoute,
                    query: {
                        idTrip,
                    },
                });
            }
            this.idTrip = idTrip;
            this.$store.dispatch(ACTION_ROUTE, idTrip);
        },
        async save(this: any) {
            if (this.hasAutoSave || this.isChanged) {
                await this.$store.dispatch(ACTION_SAVE_ROUTE, this.idTrip);
            }
            if (this.prevRoute && this.prevRoute.params.plateId) {
                this.$router.go(-1);
            }
        },
        emptyRoute(this: any, isSelected: boolean) {
            const queryIdTrip = this.$router.currentRoute.query.idTrip;
            if (!isSelected && queryIdTrip) {
                this.$router.replace({
                    ...this.$router.currentRoute,
                    query: {},
                });
            }
            this.$store.commit(ACTION_EMPTY_ROUTE);
        },
        getLabel(this: any) {
            if (!this.hasAutoSave && !this.isChanged) {
                return this.$t('common.btnClose');
            }

            if (this.isChanged) {
                return this.$t('fleetPlanning.modifiedRouteConfirmation');
            }

            if (this.hasAutoSave) {
                return this.$t('fleetPlanning.confirmationProposedRoute');
            }

            return this.$t('fleetPlanning.confirmation');
        },
        showConfig(this: any) {
            this.$refs.configurator.show();
        },
        tabChanged(this: any) {
            this.emptyRoute(this.loadDispo);
        },
    },
};
